import restFactory from 'v2/utils/restFactory';
import { MultiPartUploadResponse, PresignedURL } from 'v2/models';

type UploadedPart = {
  PartNumber: number;
  ETag: string;
};

type FileInfo = {
  id: number;
  fileName: string;
  uploadId: string;
  urls: PresignedURL[];
  fileId: string;
  filePath: string;
};

export interface BaseFile {
  name: string;
  size: number;
  webkitRelativePath?: string; // firefox
  fullPath?: string; // chrome
}

const filesUrl = '/dj/api/v1/file_upload/';

export class s3Uploader {
  constructor(public filesInfo: FileInfo[] = []) {}

  async getFileUrls(file: BaseFile): Promise<string> {
    const fileData = {
      file_name: file.name,
      size: file.size,
      file_path: file.webkitRelativePath || file.fullPath || '',
    };
    const response = await restFactory.post<MultiPartUploadResponse>(
      filesUrl,
      fileData
    );
    const fileInfo: FileInfo = {
      id: response.id,
      fileName: file.name,
      uploadId: response.multipart_data.upload_id,
      urls: response.multipart_data.presigned_urls,
      fileId: response.file,
      filePath: file.webkitRelativePath || file.fullPath || '',
    };
    this.filesInfo.push(fileInfo);
    return response.file;
  }

  getUploadUrl(fileId: string, partNumber: number) {
    const fileInfo = this.filesInfo.find((file) => file.fileId === fileId);
    const url = fileInfo?.urls.find((url) => url.part === partNumber);
    return url?.presigned_url ?? '';
  }

  completeMultipartUpload = async (fileId: string, parts: UploadedPart[]) => {
    const fileInfo = this.filesInfo.find((file) => file.fileId === fileId);
    const data = {
      upload_id: fileInfo?.uploadId,
      parts: parts,
    };
    await restFactory.post(
      `${filesUrl}${fileInfo?.id}/complete_multipart_upload/`,
      data
    );
  };
}
